import React, { useState, useEffect, useContext } from "react";
import { MentionsInput, Mention } from 'react-mentions'
import { getChartDetails } from "../../services/chartService";
import { getProjectMembers } from "../../services/managerWorkListService";
import { useLocation } from "react-router-dom";
import "./ChartForm.css";
import CommentContext from "../../Context/CommentContext/CommentContext";
import { imageIdGenerate } from "../../utils/custom";
import localStorageStore from "../../utils/localStorageStore";
import role from "../../utils/role";
import AuthContext from "../Auth/Middleware/AuthContext";
import CommentEditHistoryModal from "./CommentEditHistoryModal";

const COMMENT_MAX_LENGTH = 2000;

const clampComment = (value = "") => (value.length > COMMENT_MAX_LENGTH ? value.slice(0, COMMENT_MAX_LENGTH) : value);

const commentInputStyle = {
  control: {
    minHeight: 112,
    maxHeight: 192,
  },
  highlighter: {
    padding: "0.5rem 1rem",
    overflow: "hidden",
    border: "none",
  },
  input: {
    padding: "0.5rem 1rem",
    overflow: "auto",
    border: "none",
    outline: "none",
    resize: "none",
  },
};

function ChartComments({ id, data, enabled }) {
  const navigateStateGlobal = useLocation();
  const authContext = useContext(AuthContext);
  const [comment, setComment] = useState([]);
  const [reply, setreply] = useState(false);
  const [textcomment, settextcomment] = useState(true);
  const [accept, setAccept] = useState(false);
  const [reject, setReject] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [historyCommentId, setHistoryCommentId] = useState(null);
  const [isComment, setIsComment] = useState(false);
  const [inndex, setIndex] = useState();
  const [replyIndex, setReplyIndex] = useState();
  const [parentId, setParentId] = useState();
  const [userList, setUserList] = useState([]);
  const [taggedUser, setTaggedUser] = useState([]);
  const { commentInpval, setCommnetInpval, errorsFromAuditorToChart, errors, errorsForChat, setCommentedInCommentLog } = useContext(CommentContext);

  const isOwnComment = (UserId) => {
    const loginUserId = authContext?.loginUserId ?? localStorage.getItem("loginUserId");
    return UserId != null && loginUserId != null && parseInt(UserId) === parseInt(loginUserId);
  };

  useEffect(() => {
    if (data.WorklistId) {
      getProjectMembers(data.WorklistId).then((response) => {
        const userArray = [];
        response?.data?.forEach((user) => {
          if (!taggedUser.includes(user.id)) {
            const userObject = { id: user.id, display: `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() };
            userArray.push(userObject);
          }
        });
        setUserList(userArray);
      });
    }
  }, [data.WorklistId, taggedUser]);

  useEffect(() => {
    if(commentInpval?.comment_msg){
      const taggedUserRegex = /@\[[^\]]+\]\((\d+)\)/g;
      const matches = [];
      let match;
      while ((match = taggedUserRegex.exec(commentInpval.comment_msg)) !== null) {
        matches.push(Number(match[1]));
      }
      setTaggedUser(matches);
    }
  }, [commentInpval?.comment_msg]);

  useEffect(() => {}, [inndex, errorsForChat, errors]);

  const submitReply = (e, indexForReplies, pid) => {
    e.preventDefault();
    setIndex(indexForReplies);
    if (pid == null) {
      setParentId(null);
    } else {
      setParentId(pid);
    }
    settextcomment(false);
    setreply(true);
    setAccept(false);
    setReject(false);
    setEdit(false);
    setEditingCommentId(null);
  };

  const submitEdit = (e, cmt_index, reply_index) => {
    e.preventDefault();
    const hasReplyIndex = reply_index !== null && reply_index !== undefined && reply_index !== "";
    const target = hasReplyIndex ? comment?.[cmt_index]?.Replies?.[reply_index] : comment?.[cmt_index];
    if (!target) return;
    setIndex(cmt_index);
    setReplyIndex(hasReplyIndex ? reply_index : null);
    setEditingCommentId(target.id);
    settextcomment(false);
    setreply(false);
    setAccept(false);
    setReject(false);
    setEdit(true);
    setCommnetInpval((prev) => ({ ...(prev || {}), comment_msg: target.comment_msg ?? "" }));
  };

  const showCommentBox = () => {
    setreply(false);
    setAccept(false);
    setReject(false);
    setEdit(false);
    setEditingCommentId(null);
    settextcomment(true);
    setCommnetInpval((prev) => ({ ...(prev || {}), comment_msg: "" }));
    document.querySelector("#commentLabel button").classList.add("d-none");
    document.querySelector("#commentLabel span").innerHTML = "";
  };

  const bindReplyEvents = () => {
    document.querySelectorAll(".reply-quick-actions .menu-item").forEach((link) => {
      link.addEventListener("click", (event) => {
        const reply_action = event.target.getAttribute("data-action-type");
        const cmt_index = event.target.getAttribute("data-cmt-index");
        const reply_index = event.target.getAttribute("data-reply-index");
        const parent_id = event.target.getAttribute("data-el-parentid");
        let msg_author = "";
        let msg_body = "";
        if (reply_action !== "none") {
          if (reply_index) {
            msg_author = document.querySelector('span[data-msgid-author="' + cmt_index + "-" + reply_index + '"]').getAttribute("data-msg-author-name");
            msg_body = document.querySelector('span[data-msg-body="' + cmt_index + "-" + reply_index + '"]').innerHTML;
          } else {
            msg_author = document.querySelector('span[data-msgid-author="' + cmt_index + '-"]').getAttribute("data-msg-author-name");
            msg_body = document.querySelector('span[data-msg-body="' + cmt_index + '-"]').innerHTML;
          }
          const comment_quote = msg_author + ': "' + msg_body + '"';
          const comment_quote_italic = "<i>" + comment_quote.slice(0, 45).trim() + "...</i>";
          document.querySelector("#commentLabel button").classList.remove("d-none");
          if (reply_action === "accept") {
            document.querySelector("#commentLabel span").innerHTML = "Accepting Comment: " + comment_quote_italic;
            if (reply_index) {
              submitAccept(event, cmt_index, reply_index, parent_id);
            } else {
              submitAcceptText(event, cmt_index, parent_id);
            }
          } else if (reply_action === "reject") {
            document.querySelector("#commentLabel span").innerHTML = "Rejecting Comment: " + comment_quote_italic;
            if (reply_index) {
              submitReject(event, cmt_index, reply_index, parent_id);
            } else {
              submitRejectText(event, cmt_index, parent_id);
            }
          } else if (reply_action === "reply") {
            document.querySelector("#commentLabel span").innerHTML = "Reply to: " + comment_quote_italic;
            submitReply(event, cmt_index, parent_id);
          } else if (reply_action === "edit") {
            document.querySelector("#commentLabel span").innerHTML = "Editing Comment: " + comment_quote_italic;
            submitEdit(event, cmt_index, reply_index);
          }
        }
      });
    });
  };

  const submitAccept = (e, cmt_index, index, pid) => {
    e.preventDefault();
    setReplyIndex(index);
    setIndex(cmt_index);
    if (pid == null) {
      setParentId(null);
    } else {
      setParentId(pid);
    }
    settextcomment(false);
    setreply(false);
    setAccept(true);
    setReject(false);
    setEdit(false);
    setEditingCommentId(null);
  };

  const submitReject = (e, cmt_index, indexForReplies, pid) => {
    e.preventDefault();
    setReplyIndex(indexForReplies);
    setIndex(cmt_index);
    if (pid == null) {
      setParentId(null);
    } else {
      setParentId(pid);
    }
    settextcomment(false);
    setreply(false);
    setAccept(false);
    setReject(true);
    setEdit(false);
    setEditingCommentId(null);
  };

  const submitAcceptText = (e, indexForReplies, pid) => {
    e.preventDefault();
    setIndex(indexForReplies);
    if (pid == null) {
      setParentId(null);
    } else {
      setParentId(pid);
    }
    settextcomment(false);
    setreply(false);
    setAccept(true);
    setReject(false);
    setEdit(false);
    setEditingCommentId(null);
  };

  const submitRejectText = (e, indexForReplies, pid) => {
    e.preventDefault();
    setIndex(indexForReplies);
    if (pid == null) {
      setParentId(null);
    } else {
      setParentId(pid);
    }
    settextcomment(false);
    setreply(false);
    setAccept(false);
    setReject(true);
    setEdit(false);
    setEditingCommentId(null);
  };

  const callReply = (e) => {
    const value = clampComment(e.target.value ?? "");
    const name = "comment_msg";

    setCommnetInpval((prev) => {
      const base = prev || {};
      const repliesLength = comment[inndex]?.Replies?.length ?? 0;
      if (parentId === null && repliesLength === 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "3",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId === null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "3",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId != null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.Replies[replyIndex]?.parent_id,
          FlagId: "3",
          FlaggedCommentId: comment[inndex]?.Replies[replyIndex]?.id,
        };
      } else {
        return base;
      }
    });
  };

  const callAccept = (e) => {
    const value = clampComment(e.target.value ?? "");
    const name = "comment_msg";

    setCommnetInpval((prev) => {
      const base = prev || {};
      const repliesLength = comment[inndex]?.Replies?.length ?? 0;
      if (parentId == null && repliesLength === 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "1",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId === null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "1",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId != null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.Replies[replyIndex]?.parent_id,
          FlagId: "1",
          FlaggedCommentId: comment[inndex]?.Replies[replyIndex]?.id,
        };
      } else {
        return base;
      }
    });
  };

  const callReject = (e) => {
    const value = clampComment(e.target.value ?? "");
    const name = "comment_msg";

    setCommnetInpval((prev) => {
      const base = prev || {};
      const repliesLength = comment[inndex]?.Replies?.length ?? 0;
      if (parentId === null && repliesLength === 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "2",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId === null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.id,
          FlagId: "2",
          FlaggedCommentId: comment[inndex]?.id,
        };
      } else if (parentId != null && repliesLength > 0) {
        return {
          ...base,
          [name]: value ?? "",
          parent_id: comment[inndex]?.Replies[replyIndex]?.parent_id,
          FlagId: "2",
          FlaggedCommentId: comment[inndex]?.Replies[replyIndex]?.id,
        };
      } else {
        return base;
      }
    });
  };

  const handleKeypress = (e) => {
    if (e.keyCode !== 13) return;

    if (e.shiftKey) {
      setCommnetInpval((prev) => ({
        ...(prev || {}),
        comment_msg: clampComment((prev?.comment_msg ?? "") + "\n"),
      }));
      return;
    }

    const message = commentInpval?.comment_msg ?? "";
    if (!message.trim() || message.length > COMMENT_MAX_LENGTH) {
      e.preventDefault();
      return;
    }

    const { parsedComment, taggedUsers } = getParsedComment(message);
    setCommentedInCommentLog(true);
    const wasEditing = edit;
    const commentIdBeingEdited = editingCommentId;
    settextcomment(true);
    setreply(false);
    setAccept(false);
    setReject(false);
    setEdit(false);
    setEditingCommentId(null);
    if (wasEditing) {
      handleEditSubmit(e, parsedComment, commentIdBeingEdited);
    } else {
      handleSubmit(e, parsedComment, taggedUsers);
    }
    document.querySelector("#commentLabel button").classList.add("d-none");
    document.querySelector("#commentLabel span").innerHTML = "";
  };
  
  const getParsedComment = (str = "") => {
    const safeStr = str ?? "";
    const commentWithoutUserIdRegex = /@\[(.*?)\]\(\d+\)/g;
    const taggedUserIdRegex = /@\[[^\]]+\]\((\d+)\)/g;
    const parsedComment = safeStr.replace(commentWithoutUserIdRegex, '@[$1]');
    const taggedUsers = Array.from(safeStr.matchAll(taggedUserIdRegex), match => Number(match[1]));

    return { parsedComment, taggedUsers };
  };

  const handleSubmit = (e, parsedComment, taggedUsers) => {
    e.preventDefault();
    if ((parsedComment ?? "").length > COMMENT_MAX_LENGTH) {
      return;
    }
    fetch(`${process.env.REACT_APP_API_HOST}/charts/${id}/comments`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify({...commentInpval, comment_msg: parsedComment, taggedUsers}),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          setIsComment(true);
          getChartDetails(id);
          window.KTMenu.init();
          setCommnetInpval(prev => ({...prev, comment_msg: ""}));
        } else {
          window.toastr.error(data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    e.target.value = "";
    setTaggedUser([]);
  };

  const handleEditSubmit = (e, parsedComment, commentId) => {
    e.preventDefault();
    if (!commentId || (parsedComment ?? "").length > COMMENT_MAX_LENGTH) {
      return;
    }
    fetch(`${process.env.REACT_APP_API_HOST}/charts/${id}/comments/${commentId}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify({ comment_msg: parsedComment }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          setIsComment(true);
          window.KTMenu.init();
          setCommnetInpval((prev) => ({ ...prev, comment_msg: "" }));
          window.toastr.success(data?.message);
        } else {
          window.toastr.error(data?.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    e.target.value = "";
  };

  const getdata = (e) => {
    const value = clampComment(e.target.value ?? "");
    const name = "comment_msg";
    setCommnetInpval((prev) => ({
      ...(prev || {}),
      [name]: value,
      UserId: data?.UserId,
    }));
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_HOST}/charts/${id}/comments`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      mode: "cors",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success === false) {
          window.toastr.error(data?.message ?? "Could not load comments");
        }
        setComment(data.data ?? []);
        setIsComment(false);
        setTimeout(() => {
          window.KTMenu.init();
          bindReplyEvents();
        }, 500);
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComment, navigateStateGlobal]);

  const decryptRole = localStorageStore.getRole();
  const isCommentInputDisabled = decryptRole === role.Manager || decryptRole === role.TeamLead || decryptRole === role.Member || decryptRole === role.Admin ? false : !enabled;
  const commentLength = commentInpval?.comment_msg?.length ?? 0;
  const remainingChars = COMMENT_MAX_LENGTH - commentLength;
  const charCountClass = remainingChars <= 0 ? "text-danger fw-semibold" : remainingChars <= 200 ? "text-warning fw-semibold" : "text-muted";

  const renderCommentInput = (placeholder, onChange) => (
    <MentionsInput
      className="comments-textarea"
      style={commentInputStyle}
      onKeyDown={handleKeypress}
      onChange={onChange}
      placeholder={placeholder}
      value={commentInpval?.comment_msg ?? ""}
      disabled={isCommentInputDisabled}
      maxLength={COMMENT_MAX_LENGTH}
      rows={4}
      a11ySuggestionsListLabel="User suggestions"
      allowSuggestionsAboveCursor
    >
      <Mention trigger="@" data={userList} appendSpaceOnAdd={true} displayTransform={(id, display) => `@${display}`} />
    </MentionsInput>
  );

  return (
    <div className="p-0">
      <div className="col-12 mt-6">
        <div className="card card-flush pb-3 comment-card">
          <div className="card-header py-4 minimize">
            <p className="card-title align-items-start flex-column">
              <span className="w-bold h4">Comments {comment && comment.length ? `(${comment.length})` : ""}</span>
              <span className="text-muted mt-1 fw-semibold fs-6">Internal comments within the team</span>
            </p>
            <div className="card-toolbar mt-0">
              <button className="btn btn-icon btn-sm btn-light-primary justify-content-center minimize">
                <i className={`fas ${comment && comment.length ? 'fa-minus' : 'fa-plus'}`} />
              </button>
            </div>
          </div>
          <div className={`card-body py-2 ${comment && comment.length ? '' : 'collapse'}`}>
            <div className="mt-0 overflow-scroll" style={{ maxHeight: "25em", scrollbarWidth: "thin", scrollbarColor: `var(--bs-scrollbar-color) transparent` }}>
              {data &&
                comment?.map((item, cmt_index) => {
                  return (
                    <div key={`${item.id}_${cmt_index}`}>
                      <div className="card d-flex flex-row p-5 mt-1 border border-dashed border-gray-300 rounded">
                        <div className="symbol symbol-45px symbol-circle">
                          <img alt="Pic" src={item.user_image_url ?? `../assets/media/avatars/300-${imageIdGenerate(item?.UserId ?? "4")}.jpg`} />
                        </div>
                        <div className="flex-fill ms-5">
                          <div className="d-flex flex-wrap justify-content-between">
                            <span className="mb-1 author fw-bold" data-msgid-author={cmt_index + "-"} data-msg-author-name={item?.user_first_name + " " + item?.user_last_name}>
                              {item?.user_first_name} {item?.user_last_name}
                              <br />
                              <small className="text-muted msg-time">{item?.comment_timestamp}</small>
                              {item?.edited_at && (
                                <>
                                  {" "}
                                  <small className="text-muted fst-italic cursor-pointer text-decoration-underline" role="button" onClick={() => setHistoryCommentId(item.id)}>
                                    (edited)
                                  </small>
                                </>
                              )}
                            </span>
                            <div className="card-toolbar">
                              <button className="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end align-items-baseline" disabled={isOwnComment(item?.UserId) ? false : (decryptRole === role.Manager || decryptRole === role.TeamLead || decryptRole === role.Admin || decryptRole === role.Member ? false : !enabled)} data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                                <span className="svg-icon svg-icon-1">
                                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x={2} y={2} width={20} height={20} rx={4} fill="currentColor" />
                                    <rect x={11} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                    <rect x={15} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                    <rect x={7} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                  </svg>
                                </span>
                              </button>
                              <div className="reply-quick-actions menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                                <div className="menu-item px-3">
                                  <div className="menu-content fs-6 text-dark fw-bold px-3 py-4" data-cmt-index={cmt_index} data-action-type="none">
                                    Quick Actions
                                  </div>
                                </div>
                                <div className="separator mb-3 opacity-75" />
                                <div className="menu-item px-3">
                                  <div className="menu-link px-3" data-action-type="accept" data-cmt-index={cmt_index} data-el-parentid={item?.parent_id}>
                                    Accept
                                  </div>
                                </div>
                                <div className="menu-item px-3">
                                  <div className="menu-link px-3" data-action-type="reject" data-cmt-index={cmt_index} data-el-parentid={item?.parent_id}>
                                    Reject
                                  </div>
                                </div>
                                <div className={`menu-item px-3${isOwnComment(item?.UserId) ? "" : " pb-5"}`}>
                                  <div className="menu-link px-3" data-action-type="reply" data-cmt-index={cmt_index} data-el-parentid={item?.parent_id}>
                                    Reply
                                  </div>
                                </div>
                                {isOwnComment(item?.UserId) && (
                                  <div className="menu-item px-3 pb-5">
                                    <div className="menu-link px-3" data-action-type="edit" data-cmt-index={cmt_index} data-el-parentid={item?.parent_id}>
                                      Edit
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <span className="text-gray-800 text-break" data-msg-body={cmt_index + "-"}
                            dangerouslySetInnerHTML={{
                              __html: item?.comment_msg.replace(/@\[([^\]]+)\]/g, '<span class="badge badge-primary">@$1</span>').replace(/\n/g, '<br>'),
                            }}
                          />
                          <div className="d-flex flex-wrap justify-content-between">
                            <span className="mb-0 author" />
                            {comment[cmt_index]?.Flag === "Accepted" ? (
                              <small className="text-muted msg-time">
                                <span className="badge bg-light-success text-success">{comment[cmt_index]?.Flag}</span>
                              </small>
                            ) : (
                              ""
                            )}
                            {comment[cmt_index]?.Flag === "Rejected" ? (
                              <small className="text-muted msg-time">
                                <span className="badge bg-light-danger text-danger">{comment[cmt_index]?.Flag}</span>
                              </small>
                            ) : (
                              ""
                            )}
                            {comment[cmt_index]?.Flag === "Reply" ? "" : ""}
                          </div>
                        </div>
                      </div>
                      {item.Replies?.map((record, indexForReplies) => {
                        return (
                          <div className="card d-flex flex-row p-5 mt-1 border border-dashed border-gray-300 rounded chart-comments-reply" style={{ marginLeft: "22px" }} key={`${record.id}_${indexForReplies}`}>
                            <div className="symbol symbol-45px symbol-circle">
                              <img alt="Pic" src={record.user_image_url ?? `../assets/media/avatars/300-${imageIdGenerate(record?.UserId ?? "4")}.jpg`} />
                            </div>
                            <div className="flex-fill ms-5">
                              <div className="d-flex flex-wrap justify-content-between">
                                <span className="h6 mb-1 author" data-msgid-author={cmt_index + "-" + indexForReplies} data-msg-author-name={record?.user_first_name + " " + record?.user_last_name}>
                                  {record?.user_first_name} {record?.user_last_name}
                                  <br />
                                  <small className="text-muted msg-time">{record?.comment_timestamp}</small>
                                  {record?.edited_at && (
                                    <>
                                      {" "}
                                      <small className="text-muted fst-italic" role="button" onClick={() => setHistoryCommentId(record.id)}>
                                        (edited)
                                      </small>
                                    </>
                                  )}
                                </span>
                                <div className="card-toolbar">
                                  <button className="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end" disabled={isOwnComment(record?.UserId) ? false : (decryptRole === role.Manager || decryptRole === role.TeamLead ? false : !enabled)} data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                                    <span className="svg-icon svg-icon-1">
                                      <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect opacity="0.3" x={2} y={2} width={20} height={20} rx={4} fill="currentColor" />
                                        <rect x={11} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                        <rect x={15} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                        <rect x={7} y={11} width="2.6" height="2.6" rx="1.3" fill="currentColor" />
                                      </svg>
                                    </span>
                                  </button>
                                  <div className="reply-quick-actions menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                                    <div className="menu-item px-3">
                                      <div className="menu-content fs-6 text-dark fw-bold px-3 py-4">Quick Actions</div>
                                    </div>
                                    <div className="separator mb-3 opacity-75" />
                                    <div className="menu-item px-3">
                                      <div className="menu-link px-3" data-action-type="accept" data-cmt-index={cmt_index} data-reply-index={indexForReplies} data-el-parentid={record?.parent_id}>
                                        Accept
                                      </div>
                                    </div>
                                    <div className={`menu-item px-3${isOwnComment(record?.UserId) ? "" : " pb-5"}`}>
                                      <div className="menu-link px-3" data-action-type="reject" data-cmt-index={cmt_index} data-reply-index={indexForReplies} data-el-parentid={record?.parent_id}>
                                        Reject
                                      </div>
                                    </div>
                                    {isOwnComment(record?.UserId) && (
                                      <div className="menu-item px-3 pb-5">
                                        <div className="menu-link px-3" data-action-type="edit" data-cmt-index={cmt_index} data-reply-index={indexForReplies} data-el-parentid={record?.parent_id}>
                                          Edit
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <span className="text-muted text-break" data-msg-body={cmt_index + "-" + indexForReplies}
                                dangerouslySetInnerHTML={{
                                  __html: record?.comment_msg.replace(/@\[([^\]]+)\]/g, '<span class="badge badge-primary">@$1</span>').replace(/\n/g, '<br>'),
                                }}
                              >
                              </span>
                              <div className="d-flex flex-wrap justify-content-between">
                                <span className="h6 mb-1 author" />
                                {comment[cmt_index]?.Replies[indexForReplies]?.Flag === "Accepted" ? (
                                  <small className="text-muted msg-time">
                                    <span className="badge bg-light-success text-success">{comment[cmt_index]?.Replies[indexForReplies]?.Flag}</span>
                                  </small>
                                ) : (
                                  ""
                                )}
                                {comment[cmt_index]?.Replies[indexForReplies]?.Flag === "Rejected" ? (
                                  <small className="text-muted msg-time">
                                    <span className="badge bg-light-danger text-danger">{comment[cmt_index]?.Replies[indexForReplies]?.Flag}</span>
                                  </small>
                                ) : (
                                  ""
                                )}
                                {comment[cmt_index]?.Replies[indexForReplies]?.Flag === "Reply" ? "" : ""}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
            </div>
            <div className="mt-5">
              <label id="commentLabel" className="form-label">
                <span className="text-muted"></span>
                <button className="btn p-1 px-4 d-none" onClick={showCommentBox}>
                  <i className="fa fa-times"></i>
                </button>
              </label>
              {textcomment && renderCommentInput("Comment for task...", getdata)}
              {reply && renderCommentInput("Reply on comment...", callReply)}
              {accept && renderCommentInput("Acceptance message...", callAccept)}
              {reject && renderCommentInput("Rejection message...", callReject)}
              {edit && renderCommentInput("Edit your comment...", getdata)}
              <div className="d-flex justify-content-between align-items-center mt-2 px-1">
                <small className="text-muted">Maximum 2,000 characters</small>
                <small className={charCountClass}>
                  {commentLength.toLocaleString()} / {COMMENT_MAX_LENGTH.toLocaleString()}
                </small>
              </div>

              {errors.comment_msg && (commentInpval?.comment_msg === undefined || commentInpval?.comment_msg?.trim() === "") && <p className="help is-danger errorDanger">{errors.comment_msg}</p>}
              {errorsForChat.comment_msg && (commentInpval?.comment_msg === undefined || commentInpval?.comment_msg?.trim() === "") && <p className="help is-danger errorDanger">{errorsForChat.comment_msg}</p>}
              {errorsFromAuditorToChart.comment_msg && (commentInpval?.comment_msg === undefined || commentInpval?.comment_msg?.trim() === "") && <p className="help is-danger errorDanger">{errorsFromAuditorToChart.comment_msg}</p>}
            </div>
          </div>
        </div>
      </div>
      <CommentEditHistoryModal
        chartId={id}
        commentId={historyCommentId}
        show={!!historyCommentId}
        onClose={() => setHistoryCommentId(null)}
      />
    </div>
  );
}
export default ChartComments;
